import { getThumbmark } from "@thumbmarkjs/thumbmarkjs";

let fingerprint: string | undefined;

/**
 * ⚠️ This operation is really slow, it blocks the main thread for at least 4 seconds.
 * Use this sparingly and only when absolutely necessary.
 *
 * Returns the current device fingerprint
 */
const getFingerprintHeader = async (): Promise<{
  "x-fs-client-fingerprint": string | undefined;
}> => {
  if (!fingerprint) {
    try {
      const result = await getThumbmark();
      fingerprint = result?.thumbmark;
    } catch (error) {
      fingerprint = undefined;
    }
  }

  return { "x-fs-client-fingerprint": fingerprint };
};

export { getFingerprintHeader };
